export const uploadTransactionHeaders = [
    'Date *',
    'Description *',
    'Amount *',
    'Card number (or 4 digits)',
];

export const requiredTransactionHeaders = uploadTransactionHeaders.filter((header) =>
    header.includes('*'),
);
